import React from 'react';
import { Box, Stack } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { Dayjs } from 'dayjs';
import { Button } from 'src/UIKit';
import { TimePeriod } from '../../controllers/ReportsViewController';
import { ReportsFilters } from '../ReportsFilters/ReportsFilters';

interface ReportsHeaderProps {
  timePeriod: TimePeriod;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  onTimePeriodChange: (period: TimePeriod) => void;
  onStartDateChange: (date: Dayjs | null) => void;
  onEndDateChange: (date: Dayjs | null) => void;
  onRefresh?: () => void;
}

export const ReportsHeader: React.FC<ReportsHeaderProps> = ({
  timePeriod,
  startDate,
  endDate,
  onTimePeriodChange,
  onStartDateChange,
  onEndDateChange,
  onRefresh,
}) => (
  <Stack gap={2} mb={3}>
    <ReportsFilters
      timePeriod={timePeriod}
      startDate={startDate}
      endDate={endDate}
      onTimePeriodChange={onTimePeriodChange}
      onStartDateChange={onStartDateChange}
      onEndDateChange={onEndDateChange}
    />
    {onRefresh && (
      <Box>
        <Button variant="outlined" onClick={onRefresh} startIcon={<RefreshIcon />} size="small">
          Refresh
        </Button>
      </Box>
    )}
  </Stack>
);
